import imgSectionSolution from '../../resource/image/section-solution.png'
import imgSectionProduct from '../../resource/image/section-product.png'
import VideoMockup from "../common/VideoMockup";

const SectionSolution = () => {
    return (
        <div className='container mx-auto h-full pt-16 md:pt-24 pb-3 md:pb-6'>
            <div className="mb-10 border-b border-black pb-6 text-center">
                <h2 className="text-[clamp(32px,5vw,64px)] font-bold text-black leading-tight tracking-tight">SOLUTION</h2>
            </div>
            <div className='flex flex-col gap-12'>
                <div className='flex flex-col md:flex-row items-center justify-between gap-6'>
                    <img src={imgSectionSolution} alt="AMR Platform" className='w-full md:w-[55%] object-contain' />
                    <div className='w-full md:w-[45%]'>
                        <VideoMockup videoSrc="/videos/loop-solution.webm" />
                    </div>
                </div>
                <div className='flex flex-col md:flex-row items-center justify-between gap-6'>
                    <img src={imgSectionProduct} alt="AMR Platform" className='w-full md:w-[55%] object-contain' />
                    <div className='w-full md:w-[45%]'>
                        <VideoMockup videoSrc="/videos/loop-product.webm" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SectionSolution;